import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import RescheduleForm from './RescheduleForm';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
import { faArrowsUpDownLeftRight } from '@fortawesome/free-solid-svg-icons';

class RescheduleDialog extends Component
{
	dialogConfig() {
		const { onCancel, initialValues, t } = this.props;
		const movedSessionDate = initialValues && `${ui.formatDate(initialValues.sessionDate)} ${ui.formatTime(initialValues.startTime)} - ${ui.formatTime(initialValues.endTime)}`;

		return {
			header: `${t('WorkshopPayment_RescheduleSessionTitle', { movedSessionDate: movedSessionDate })}`,
			body: this.renderBody(),
			onHide: onCancel,
			footer: this.renderFooter()
		};
	}

	renderBody() {
		const { onConfirm, initialValues, workshopSessions, ...rest } = this.props;
		return <RescheduleForm onSubmit={onConfirm} workshopSessions={workshopSessions}
			initialValues={initialValues} {...rest} />;
	}

	renderFooter() {
		const { onCancel, t } = this.props;

		const closeBtn = <Button key = 'close' onClick ={ onCancel}>{ t('Common_Close')}</Button>;
		const confirmBtn = < RemoteSubmitButton key='reschedule' style='success' formName='rescheduleForm'
			label={t('ChildSession_ConfirmReschedule')} icon={faArrowsUpDownLeftRight}/>
		
		return [closeBtn, confirmBtn];
	}

	render() {
		const { show, block, unblock } = this.props;
		return <Dialog config={this.dialogConfig()}
		show ={show}
		block ={block}
		unblock ={unblock} />;
	}
}

RescheduleDialog.propTypes = {
show: PropTypes.bool,
block: PropTypes.oneOfType([
	PropTypes.instanceOf(RegExp),
	PropTypes.string,
	PropTypes.array,
	PropTypes.func
]),
	unblock: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(RescheduleDialog);